import {
    BackCta,
    Column,
    Icon,
    Link,
    Row,
    Text,
    IconWithBackground,
    MediaStack,
    MEDIA,
    Tooltip
} from "@bridgesplit/ui";
import { COPY, LEND_SLUG } from "app/constants";
import { doNothing } from "@bridgesplit/utils";
import { OpenHowItWorks } from "app/components/common/market";
import { MarketGuideMode } from "@bridgesplit/abf-react";
import { TokenImageForVault } from "app/components/explore/vaults/VaultTitle";
import { useMediaQuery } from "@mui/material";

import { useVaultContext } from "../../VaultContext";

export default function VaultDetailHeader() {
    const { vaultExpanded } = useVaultContext();

    return (
        <Column spacing={2}>
            <Link to={LEND_SLUG}>
                <BackCta back={doNothing} backCta={`All ${COPY.VAULT_TERM_PLURAL}`} />
            </Link>

            <MediaStack spacing={2} spaceBetweenRow>
                <Row spacing={1}>
                    <TokenImageForVault vaultExpanded={vaultExpanded} />
                    <Text variant="h3">{vaultExpanded?.vaultMetadata?.name}</Text>
                    {vaultExpanded?.vaultMetadata?.isGenesisVault && <GenesisVaultTag />}
                </Row>
                <Row spacing={1}>
                    {vaultExpanded && (
                        <OpenHowItWorks
                            variant="outlined"
                            mode={MarketGuideMode.LendVault}
                            vaultExpanded={vaultExpanded}
                        />
                    )}
                </Row>
            </MediaStack>
        </Column>
    );
}

function GenesisVaultTag() {
    const isMobile = useMediaQuery(MEDIA.SM.below);
    return (
        <Tooltip title={COPY.GENESIS_VAULT_DETAILS}>
            <IconWithBackground
                tagColor="body"
                sx={{
                    borderRadius: "20px",
                    px: 2,
                    py: 0.75,
                    width: "auto",
                    maxWidth: "none",
                    minWidth: "auto",
                    height: "auto",
                    maxHeight: "none",
                    minHeight: "auto",
                    display: "flex",
                    gap: 1
                }}
                variant="body2"
            >
                <Icon type="rocket" sx={{ fontSize: "20px" }} />
                {!isMobile && COPY.VAULT_GENESIS_TERM}
            </IconWithBackground>
        </Tooltip>
    );
}
